import { Utilities as utilities } from "@truckdown/framework";
import { ThrottleAmounts } from "./ThrottleAmounts";
import { ThrottleRatios } from "./ThrottleRatios";

export class ThrottleLimits {
    constructor(json?: any) {
        if (json) {
            if (json.ms != undefined) {
                this.timedMilliseconds = json.ms as number;
            }
            if (json.max) {
                this.maxCounts = utilities.json.getObjectValue(json, (itm) => { return new ThrottleAmounts(itm); }, 'max')
                    ?? undefined;
            }
            if (json.limits) {
                this.countLimits = utilities.json.getObjectValue(json, (itm) => { return new ThrottleAmounts(itm); }, 'limits')
                    ?? undefined;
            }
            if (json.suspect) {
                this.suspectCount = utilities.json.getObjectValue(json, (itm) => { return new ThrottleAmounts(itm); }, 'suspect')
                    ?? undefined;
            }
            if (json.ratio_throttle) {
                this.ratioThrottle = json.ratio_throttle as string;
            }
            if (json.ratios) {
                this.ratios = utilities.json.getArrayValue(json, (itm) => { return new ThrottleRatios(itm); }, 'ratios')
                    ?? [];
            }
            if (json.maxWithZeroChild != undefined) {
                this.maxWithZeroChild = json.maxWithZeroChild as number;
            }
            if (json.limitWithZeroChild != undefined) {
                this.limitWithZeroChild = json.limitWithZeroChild as number;
            }
            if (json.suspectWithZeroChild != undefined) {
                this.suspectWithZeroChild = json.suspectWithZeroChild as number;
            }
            if (json.maxExpiry != undefined) {
                this.maxRatioExpiry = json.maxExpiry as number;
            }
            if (json.limitsExpiry != undefined) {
                this.countRatioExpiry = json.limitsExpiry as number;
            }
            if (json.suspectExpiry != undefined) {
                this.suspectRatioExpiry = json.suspectExpiry as number;
            }
        }
    }

    toJSON() {
        return {
            ms: this.timedMilliseconds,
            max: this.maxCounts,
            limits: this.countLimits,
            suspect: this.suspectCount,
            ratio_throttle: this.ratioThrottle,
            ratios: this.ratios,
            maxWithZeroChild: this.maxWithZeroChild,
            limitWithZeroChild: this.limitWithZeroChild,
            suspectWithZeroChild: this.suspectWithZeroChild,
            maxExpiry: this.maxRatioExpiry,
            limitsExpiry: this.countRatioExpiry,
            suspectExpiry: this.suspectRatioExpiry
        };
    }

    timedMilliseconds?: number;
    maxCounts?: ThrottleAmounts;
    countLimits?: ThrottleAmounts;
    suspectCount?: ThrottleAmounts;
    ratioThrottle?: string;
    ratios: ThrottleRatios[] = [];

    maxWithZeroChild?: number;
    limitWithZeroChild?: number;
    suspectWithZeroChild?: number;

    maxRatioExpiry?: number;
    countRatioExpiry?: number;
    suspectRatioExpiry?: number;
}